export const characters = [
  {
    id: 1,
    name: "ДЕНДЖИ",
    title: "ЧЕЛОВЕК-БЕНЗОПИЛА",
    description: "Голодный парень, который мечтает о нормальной жизни. Может превращаться в монстра с бензопилой из головы.",
    ability: "АКТИВАЦИЯ БЕНЗОПИЛЫ",
    abilityDesc: "Из головы и рук вырываются лезвия, разрезающие демонов на куски",
    bloodType: "Агрессивная кровь",
    likes: "Жареное мясо, груди, Почита",
    quote: "Я хочу обниматься!",
    color: "#cc5500",
    bgGradient: "linear-gradient(145deg, #331100, #662200)",
    icon: "⚙️"
  },
  {
    id: 2,
    name: "МАКИМА",
    title: "КОНТРОЛЁРША",
    description: "Загадочная женщина с дьявольскими способностями. Контролирует тех, кто считает себя ниже неё.",
    ability: "КОНТРОЛЬ РАЗУМА",
    abilityDesc: "Может управлять любым существом, которое чувствует себя ниже её по статусу",
    bloodType: "Таинственная кровь",
    likes: "Собаки, Денджи, власть",
    quote: "Ты станешь моей собакой",
    color: "#8b0000",
    bgGradient: "linear-gradient(145deg, #330000, #660000)",
    icon: "🐕"
  },
  {
    id: 3,
    name: "ПАУЭР",
    title: "ДЬЯВОЛ КРОВИ",
    description: "Безумная девушка, которая врёт постоянно. Лучший друг Денджи (по её мнению).",
    ability: "МАНИПУЛЯЦИЯ КРОВЬЮ",
    abilityDesc: "Управляет собственной кровью, создавая оружие и щиты",
    bloodType: "Дьявольская кровь",
    likes: "Кошки, ванна, Денджи",
    quote: "Я стану премьер-министром!",
    color: "#a52a2a",
    bgGradient: "linear-gradient(145deg, #3d1a1a, #7a3535)",
    icon: "🔨"
  },
  {
    id: 4,
    name: "АКИ",
    title: "ОХОТНИК НА ДЕМОНОВ",
    description: "Мрачный парень с контрактом на Дьявола Проклятий. Носит меч в спине.",
    ability: "ПРОКЛЯТЫЙ МЕЧ",
    abilityDesc: "Призывает гигантскую руку, уничтожающую врагов",
    bloodType: "Проклятая кровь",
    likes: "Месть, сигареты, Пауэр",
    quote: "Я убью того, кто убил мою семью",
    color: "#4a4a4a",
    bgGradient: "linear-gradient(145deg, #1f1f1f, #3d3d3d)",
    icon: "⚔️"
  },
  {
    id: 5,
    name: "ПОЧИТА",
    title: "ДЬЯВОЛ БЕНЗОПИЛЫ",
    description: "Сердце Денджи в форме милого пёсика. Самое опасное существо в аду.",
    ability: "ИСТИННАЯ ФОРМА",
    abilityDesc: "Пробуждается как настоящий Дьявол Бензопилы, уничтожая концепции",
    bloodType: "Божественная кровь",
    likes: "Кровь, Денджи, объятия",
    quote: "Вжик-вжик!",
    color: "#ff4444",
    bgGradient: "linear-gradient(145deg, #440000, #880000)",
    icon: "🐶"
  },
  {
    id: 6,
    name: "ХИМЕНО",
    title: "СТАРШАЯ ГРУППЫ",
    description: "Опытная охотница, заботящаяся о своей команде. Пьёт как не в себя.",
    ability: "ПРИЗЫВ ПРИЗРАКА",
    abilityDesc: "Призывает демона-призрака, которым управлял её погибший партнёр",
    bloodType: "Жертвенная кровь",
    likes: "Аки, выпивка, команда",
    quote: "Я хочу быть счастливой...",
    color: "#6a0dad",
    bgGradient: "linear-gradient(145deg, #2a0a3a, #541a6a)",
    icon: "👻"
  }
];